module.exports = __webpack_public_path__ + "static/img/Ryan-Matterson.8ddcdab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ryan-Matterson.jpg
// module id = hl4K
// module chunks = 0